import { navLinks, lastUpdated } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-700 text-background-50">
      <div className="mx-auto max-w-content px-4 py-12 md:py-14">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold">星辰影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              本站为星辰影院的入口导航与使用指南页，整理最新地址、客户端下载方式，以及网址打不开时的解决办法。
              整理内容不定期更新，方便你在任何设备、任何网络下快速找回可用入口。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-heading text-sm font-bold text-background-100">
              页面导航
            </h3>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2 sm:grid-cols-3 md:grid-cols-2">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="text-sm text-background-200 transition-colors hover:text-primary-300"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="max-w-xs">
            <h3 className="font-heading text-sm font-bold text-background-100">
              更新与提醒
            </h3>
            <p className="mt-3 inline-flex items-center gap-2 rounded-md bg-black/20 px-3 py-2 text-xs text-background-100">
              <i className="ri-calendar-line"></i>
              最近更新：{lastUpdated.date} {lastUpdated.time}
            </p>
            <p className="mt-3 text-xs leading-relaxed text-background-300">
              建议收藏本页并绑定邮箱。域名变更时，本页会优先同步最新可用地址。
            </p>
          </div>
        </div>

        <div className="mt-10 border-t border-white/15 pt-6">
          <p className="text-xs leading-relaxed text-background-300">
            免责声明：本页仅提供入口导航与使用指引，所有地址与状态以官方公告为准。请在符合当地法律法规的前提下使用相关服务。
          </p>
          <p className="mt-3 flex flex-col gap-1 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
            <span>© {new Date().getFullYear()} 星辰影院 · 入口导航页</span>
            <span>本站为信息整理页，不提供内容存储服务</span>
          </p>
        </div>
      </div>
    </footer>
  );
}